import { Avatar, Typography } from '@mui/material';

function AssistantAvatar() {
  return (
    <Avatar
      alt="Halo"
      sx={{
        width: 54,
        height: 30,
        fontSize: '12px',
        borderRadius: '30px',
        backgroundColor: 'primary.main',
        color:"background.default",
      }}
    >
      <Typography variant="subtitle2" fontFamily="Roboto Variable" fontWeight={500}>
        Halo
      </Typography>
    </Avatar>
  );
}

export default AssistantAvatar;
